import React from 'react';
import ConsultantWise from '../bi-report/ConsultantWise';
import './index.css';

const ResourceEffectivenessConsultant = () => {
  return (
    <div className="resource-effectiveness-consultant-container">
  
      
      <div className="consultant-section">
        <ConsultantWise />
      </div>
    </div>
  );
};

export default ResourceEffectivenessConsultant;
